import blockSuperAdmin from '@/middleware/blockSuperAdmin';

const Login = () => import('@/pages/auth/Login.vue');
const VerifyOtp = () => import('@/pages/auth/VerifyOtp.vue');
const ResetPassword = () => import('@/pages/auth/ResetPassword.vue');

const Category = () => import('@/pages/Index.vue');

const WebRTCCall = () => import('@/pages/webrtc/Call.vue');
const DialerCall = () => import('@/pages/dialer/Call.vue');
const LiveCalls = () => import('@/pages/live-calls/Index.vue');
const AdminDashboard = () => import('@/pages/dashboard/admin/Index.vue');
const AutoCallDashboard = () => import('@/pages/dashboard/autocall/Index.vue');
const AutoCallProgressiveDashboard = () => import('@/pages/dashboard/autocall-progressive/Index.vue');
const AgentDashboard = () => import('@/pages/dashboard/agent/Index.vue');
const Contacts = () => import('@/pages/contacts/Index.vue');
const Campaigns = () => import('@/pages/campaigns/Index.vue');
const CampaignReport = () => import('@/pages/campaigns/Report.vue');
const Recordings = () => import('@/pages/recordings/Index.vue');
const AuditLogs = () => import('@/pages/audit-logs/Index.vue');
const ProviderSettings = () => import('@/pages/provider-settings/Index.vue');
const CallSettings = () => import('@/pages/call-settings/Index.vue');
const Settings = () => import('@/pages/settings/Index.vue');
const Profile = () => import('@/pages/profile/Index.vue');

// User Management
const UserIndex = () => import('@/pages/user-management/user/Index.vue');
const UserCreate = () => import('@/pages/user-management/user/UserCreate.vue');
const UserEdit = () => import('@/pages/user-management/user/UserEdit.vue');
const UserGroupIndex = () =>
  import('@/pages/user-management/user-group/Index.vue');
const UserGroupForm = () =>
  import('@/pages/user-management/user-group/Form.vue');

const NotFound = () => import('@/pages/misc/404.vue');
const Unauthorized = () => import('@/pages/misc/403.vue');
const RootRedirect = () => import('@/pages/misc/RootRedirect.vue');

const routes = [
  {
    path: '/',
    name: 'Root',
    component: RootRedirect,
  },
  {
    meta: {
      layout: 'guest',
    },
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    meta: {
      layout: 'guest',
    },
    path: '/verify-otp',
    name: 'VerifyOtp',
    component: VerifyOtp,
  },
  {
    meta: {
      layout: 'guest',
    },
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/dashboard',
    component: Category,
    children: [
      {
        path: '',
        redirect: { name: 'AutoCallDashboard' },
      },
      {
        path: 'admin',
        name: 'AdminDashboard',
        component: AdminDashboard,
      },
      {
        path: 'auto-call',
        name: 'AutoCallDashboard',
        component: AutoCallDashboard,
        meta: { middleware: [blockSuperAdmin] },
      },
      {
        path: 'auto-call-progressive',
        name: 'AutoCallProgressiveDashboard',
        component: AutoCallProgressiveDashboard,
        meta: { middleware: [blockSuperAdmin] },
      },
      {
        path: 'agent',
        name: 'AgentDashboard',
        component: AgentDashboard,
        meta: { middleware: [blockSuperAdmin] },
      },
    ],
  },
  {
    path: '/management',
    component: Category,
    children: [
      {
        path: 'contacts',
        name: 'Contacts',
        component: Contacts,
      },
      {
        path: 'campaigns',
        name: 'Campaigns',
        component: Campaigns,
      },
      {
        path: 'campaigns/:id/report',
        name: 'CampaignReport',
        component: CampaignReport,
        props: true,
      },
      {
        path: 'recordings',
        name: 'Recordings',
        component: Recordings,
      },
      {
        path: 'audit-logs',
        name: 'AuditLogs',
        component: AuditLogs,
      },
    ],
  },
  {
    path: '/voip',
    component: Category,
    children: [
      {
        path: 'webrtc/call',
        name: 'WebRTCCall',
        component: WebRTCCall,
      },
      {
        path: 'dialer/call',
        name: 'DialerCall',
        component: DialerCall,
      },
      {
        path: 'live-calls',
        name: 'LiveCalls',
        component: LiveCalls,
      },
    ],
  },

  {
    path: '/profile',
    component: Category,
    children: [
      {
        path: '',
        name: 'Profile',
        component: Profile,
      },
    ],
  },
  // Some DB seeds / manual permalinks used /dashboard/...; Vue routes live under /utilities/...
  {
    path: '/dashboard/utilities/call-settings',
    redirect: { name: 'CallSettings' },
  },
  {
    path: '/dashboard/utilities/provider-settings',
    redirect: { name: 'ProviderSettings' },
  },
  {
    path: '/utilities',
    component: Category,
    children: [
      {
        path: 'provider-settings',
        name: 'ProviderSettings',
        component: ProviderSettings,
      },
      {
        path: 'call-settings',
        name: 'CallSettings',
        component: CallSettings,
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
      },
    ],
  },

  {
    path: '/user-management',
    component: Category,
    children: [
      {
        path: 'user',
        name: 'User',
        component: UserIndex,
      },
      {
        path: 'user/create',
        name: 'UserCreate',
        component: UserCreate,
      },
      {
        path: 'user/:id/edit',
        name: 'UserEdit',
        component: UserEdit,
      },
      {
        path: 'user-group',
        name: 'UserGroup',
        component: UserGroupIndex,
      },
      {
        path: 'user-group/create',
        name: 'UserGroupCreate',
        component: UserGroupForm,
      },
      {
        path: 'user-group/:id/edit',
        name: 'UserGroupEdit',
        component: UserGroupForm,
      },
    ],
  },

  {
    meta: {
      requiresAuth: false,
      skipPermissionCheck: true,
    },
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
];

export default routes;
